/** Settings for auto approving reservations */
export interface IAutoApproveReservationSettings {
	enabled: boolean

	/** Max overall no of guests in the restaurant allowed for
	 * reservation to be auto approved
	 * 0 means no limit
	 */
	guestLimitOverall: number

	/** Max no of guests allowed for reservation to be auto approved
	 * 0 means no limit
	 */
	guestLimitPerReservation: number
}

/** Settings for Google reservations */
export interface IGoogleReservationsSettings {
	enabled: boolean
}

export interface IReservationSettings {
	autoApproveReservations: IAutoApproveReservationSettings
	googleReservations: IGoogleReservationsSettings

	/** Default time of reservations */
	defaultReservationTime: number

	/** Reservations that start within this time interval (hours) are dispayed in dashboard */
	dashboardReservationTimeLimit: number

	/**
	 * Optional latest reservation start (restaurant-local wall time).
	 * No slots are offered after this time even while the restaurant is open.
	 */
	lastReservationTime?: { hours: number; minutes: number } | null
}
